<template>
  <div class="sensor-alarm">
    <div class="sensor-alarm__body">
      <div class="sensor-alarm__grid">
        <div>
          <h4 class="g-title g-title--subtitle">
            {{ $t('messages.sensors.sdAlarms.alarm') }}
          </h4>
          <button
            class="g-btn"
            :class="{'disabled': actions.length === 0}"
            @click.stop="toggle()"
          >
            <font-awesome-icon :icon="computedAngle" />
          </button>
        </div>
        <input-element
          v-if="alarmData.status && alarmData.status.seqno"
          class="input-element--center min-50"
          :title="$t('messages.sensors.sdAlarms.seqno')"
          :disabled="true"
          :text="alarm.seqno"
        />
        <input-element
          v-if="alarmData.status && alarmData.status.alrmname"
          class="input-element--center min-50"
          :title="$t('messages.sensors.sdAlarms.alrmname')"
          :disabled="true"
          :text="alarm.alrmname"
        />
        <select-element
          v-if="alarmData.status && alarmData.status.alrmtype"
          class="select-element--full"
          :title="$t('messages.sensors.sdAlarms.alrmtype')"
          :value="alarm.alrmtype"
          :list="triggers"
          @change="setValue($event.value, 'alrmtype')"
        />
        <select-element
          v-if="alarmData.status && alarmData.status.condition"
          class="select-element--full"
          :title="$t('messages.sensors.sdAlarms.condition')"
          :value="alarm.condition"
          :list="criterias"
          @change="setValue($event.value, 'condition')"
        />
        <input-element
          v-if="alarmData.status && alarmData.status.limit"
          class="input-element--center input-element--limit"
          :title="$t('messages.sensors.sdAlarms.limit')"
          :type="'number'"
          :min="-9999.99"
          :max="9999.99"
          :step="0.01"
          :text="alarm.limit"
          @change="setValue(parseFloat($event), 'limit')"
        />
        <div>
          <h4 class="g-title g-title--subtitle">
            {{ $t('messages.sensors.sdAlarms.delete') }}
          </h4>
          <button
            class="g-btn g-btn--red"
            @click.stop="$emit('delete', alarmData)"
          >
            <font-awesome-icon :icon="['fas', 'times']" />
          </button>
        </div>
      </div>
    </div>
    <transition-group
      v-show="showActions"
      name="alarm--transition"
      tag="div"
      class="sensor-alarm__actions"
    >
      <action
        v-for="action in actions"
        :key="action.data.id"
        :alarmid="alarmData.data.id"
        :action-data="action"
        :action-dropdown="actionDropdown"
        :sensors="sensors"
        :senstype="senstype"
        :ctrlid="ctrlid"
        :page-message = "PageMessage"
        @delete="deleteAction"
        @SetPageMessage="SetPageMessage"
      />
    </transition-group>
    <div
      v-if="showActions || actions.length === 0"
      class="sensor-alarm__controls"
    >
      <button
        class="g-btn  g-btn--blue"
        :class="{'disabled': disableCreate}"
        :disabled="disableCreate"
        @click.stop="createActionButtonClicked(createBlankAction())"
      >
        {{ $t('messages.sensors.sdActions.createaction') }}
      </button>
    </div>
  </div>
</template>

<script>
import {MicroService} from'@/assets/javascript/mixins/Mixins'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import InputElement from'@/components/elements/InputElement.vue'
import SelectElement from'@/components/elements/SelectElementReactive.vue'
import {convertToOptions} from '@/assets/javascript/utilities'
import SensorDecoderActioncomponent from'@/components/elements/SensorDecoderActionComponent.vue'

export default {
  name: 'EditSensorDecoderAlarm',
  components: {
    'font-awesome-icon': FontAwesomeIcon,
    'input-element': InputElement,
    'select-element': SelectElement,
    'action': SensorDecoderActioncomponent
  },
  mixins: [MicroService],
  props: {
    PageMessage: {
      type: Object,
      default: function() {
        return {}
      }
    },
    sensors: {
      type: Number,
      default: 0
    },
    ctrlid: {
      type: Number,
      default: 0
    },
    senstype: {
      type: Number,
      default: 0
    },
    alarmData: {
      type: Object,
      default: function() {
        return {}
      }
    },
    triggers: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      actions: [],
      criterias: [],
      actionDropdown: [],
      disableCreate: false,
      showActions: false
    }
  },
  computed: {
    alarm() {
      return this.alarmData ? this.alarmData.data : {}
    },
    computedAngle() {
      return !this.showActions ? ['fas', 'angle-up'] : ['fas', 'angle-down']
    },
  },
  watch: {
    PageMessage(msg) {
      if(msg && msg.target === 'sensor-decoder-action-delete') {
        const match = this.actions.find(action => action.data.id === msg.data.id)

        if(match) this.deleteAction(match)
      }
    },
    alarm: {
     handler(data, old) {
      this.getActionDropdown(data.id)
      this.getActions(data.id)
      this.getCriterias(data.alrmtype)
     },
     deep: true,
     immediate: true
    }
  },
  methods: {
    deleteClicked(data) {
      const text = this.actions.length
      ? 'Deleting this action will also delete its sub-actions.'
      : ''

      this.$emit('SetPageMessage', {
        target: 'ShowModal',
        modalData: {
          component: 'DialogueModal',
          data: {
            title: 'Delete Action?',
            prefix: 'sensor-decoder-action-',
            text,
            data,
            options: [
              {label: 'Delete', value: 'delete'}, {label: 'Cancel', value: 'cancel'}
            ]
          }
        }
      })
    },
    SetPageMessage(Message) {
      this.$emit('SetPageMessage', Message)
    },
    toggle() {
      if(this.actions.length !== 0) this.showActions = !this.showActions
    },
    createBlankAction() {
      return {
        ctrlid: this.ctrlid,  
        seqno: this.actions.length + 1,   
        alarmid: this.alarm.id, 
        index: null,   
        action: null,  
        itemtype: null,
        itemno: null,  
        delay: null,   
        forced: null,  
        message: null, 
        actionid: null
      }
    },
    createActionButtonClicked(data) {
      this.disableCreate = this.showActions = true
      this.sendMicroServiceRequest({
        method: 'PUT',
        url: `api/authenticated/function/createsdaction?senstype=${this.senstype}`,
        data
      })
      .then((response) => {
        if(response.data && response.data.createsdaction ) {
          const actionIndex = this.actions.push(response.data.createsdaction[0])
          this.disableCreate = false
        }
      })
      .catch(console.error)
      .finally(() => this.disableCreate = false)
    },
    deleteAction(data) {
      const actionIndex = this.actions.indexOf(data)

      if(actionIndex === -1) return console.error('deleteAction ERR')

      this.sendMicroServiceRequest({
        method: 'DELETE',
        url: `api/authenticated/function/deletesdaction?ctrlid=${this.ctrlid}&id=${data.id}`,
        data
      }).then((response) => {
        if(response.status !== 200) console.error(response)
        if( response.data && response.data.deletesdaction) this.actions.splice(actionIndex, 1)
      }).catch(console.error)
    },
    updateAlarm(data) {
      this.sendMicroServiceRequest({
        method: 'POST',
        url: `api/authenticated/function/updatesdalarm?ctrlid=${this.ctrlid}&senstype=${this.senstype}`,
        data
      }).then((response) => {
        if(response.status !== 200) return console.error(response)
        
        if(response && response.data && response.data.updatesdalarm)
          Object.assign(this.alarmData, response.data.updatesdalarm[0])
      }).catch(console.error)
    },
    getActions(alarmID) {
      this.sendMicroServiceRequest({
        method: 'GET',
        url: `api/authenticated/function/getsdaction?ctrlid=${this.ctrlid}&alarmid=${alarmID}`
      })
      .then((response) => {
        response.data && response.data.getsdaction
        ? this.$set(this, 'actions', response.data.getsdaction.sort((a, b) => a.seqno - b.seqno))
        : console.error('no data for getsdaction')
      }).catch(console.error)
    },
    getCriterias(alarmType) {
      this.sendMicroServiceRequest({
        method: 'GET',
        url: `api/authenticated/function/getsdalarmsecondarydropdown?senstype=${this.senstype}&enum=${alarmType}&language_code=en-US`
      })
      .then((response) => {
        response.data && response.data.getsdalarmsecondarydropdown
        ? this.$set(this, 'criterias', convertToOptions(response.data.getsdalarmsecondarydropdown, 'enum', 'lang'))
        : console.error('no data for getsdalarmsecondarydropdown')
      }).catch(console.error)
    },
    getActionDropdown(alarmID) {
      this.sendMicroServiceRequest({
        method: 'GET',
        url: `api/authenticated/function/getsdactiondropdown?alarmid=${alarmID}&senstype=${this.senstype}&language_code=en-US`
      })
      .then((response) => {
        response.data && response.data.getsdactiondropdown
        ? this.$set(this, 'actionDropdown', convertToOptions(response.data.getsdactiondropdown, 'enum', 'lang'))
        : console.error('no data for getsdactiondropdown')
      }).catch(console.error)
    },
    setValue(option, name) {
      const value = option.value !== undefined ? option.value : option
      this.$set(this.alarm, name, value)
      this.updateAlarm(Object.assign({
          id: null,
          seqno: null,
          sensid: null,
          index: null,
          alrmname: null,
          alrmtype: null,
          limit: null,
          condition: null
      }, this.alarm))
    }
  }
}
</script>
<style lang="scss">
.sensor-alarm {
  margin-bottom: 20px;
  padding-bottom: 10px;

  .action--transition {
    &-enter {
      opacity: 0;
    }
    &-enter-to {
      transition: all 0.4s;
      opacity: 1;
    }
    &-leave-to {
      transition: all 0.3s;
      opacity: 0;
    }
    // &-leave-active {
    // 	position: absolute;
    // }
    &-move {
      transition: transform 0.4s;
    }
  }

  &__controls {
    text-align: center;
    display: flex;
    align-items: flex-end;

    border-left: 1px solid #abc;
    margin-left: 24px;
    margin-bottom: 24px;

    > * {
      display: inline-block;
      transform: translateY(50%);
    }

    &:before {
      content: ' ';
      display: inline-block;
      box-sizing: border-box;
      height: 0;
      border-bottom: 1px solid #abc;
      width: 35px;
    }

    .g-btn {
      padding: 10px 10px;
      margin: 0;
      font-size: 14px;
    }
  }
  &__grid {
    display: flex;
    padding-bottom: 5px;

    > * {
      display: flex;
      justify-content: stretch;
      flex-direction: column;

      > *:not(h4) {
        height: 100%;
      }

      &.g-btn {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .no-shrink {
      flex-shrink: 0;
    }

    .min-50 {
      flex: 1 0 50px;
    }

    .g-btn {
      margin: 0 !important;
      padding: 0 !important;

      > & {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .select-element-wrapper {
      margin: 0;
      select {
        padding: 5px !important;
      }
    }

    .input-element--limit .input-element-wrapper {
      width: 80px;
    }

    .input-element-wrapper {
      padding: 0;
      input {
        padding: 5px !important;
      }
    }
  }
}
</style>
